import { SVGProps } from 'react';

export function Office(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      fill='none'
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#FFF7E6'
      />
      <path
        d='M5.33325 18.667H18.6666'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.3333 5.33301H8.66667C6.66667 5.33301 6 6.52634 6 7.99967V18.6663H18V7.99967C18 6.52634 17.3333 5.33301 15.3333 5.33301Z'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.66675 15H10.6667'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3333 15H15.3333'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.66675 12H10.6667'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3333 12H15.3333'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.66675 9H10.6667'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3333 9H15.3333'
        stroke='#FA8C16'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
